import React from 'react';
import { useBrokerDetailsStore, FormField } from '../../../state/brokerDetailsStore';
import { useBrokerFieldFieldChanged } from '../../../hooks/useBrokerFieldChanged';
import { TextBox } from '@apply/components';
import { ShowIf } from '@apply/ui';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const ArizonaLicenseField: React.FC = () => {
    const arizonaLicenseNumber = useBrokerDetailsStore((s) => s.arizonaLicenseNumber);
    const updateFields = useBrokerDetailsStore((s) => s.updateFields);
    const changed = useBrokerFieldFieldChanged(FormField.ArizonaLicenseNumber);

    return (
        <>
            <TextBox
                id='arizonaLicenseNumber'
                value={arizonaLicenseNumber}
                onChange={(v) => updateFields({ arizonaLicenseNumber: v })}
                label='Arizona License Number'
                width={'100%'}
                helperText='If you will broker deals in Arizona, please provide your license number.'
            />
            <ShowIf showIf={changed}>
                <FontAwesomeIcon
                    icon='asterisk'
                    className='required-icon'
                />
            </ShowIf>
        </>
    );
};
